import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Button from '@material-ui/core/Button';
import CancelDialog from "./cancelDialog";

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        float:'right',
        marginBottom:'5px',
        marginRight:'5px'
    },
    cancelButton: {
        background: 'red',
        color: 'white !important',
        height: 14,
        fontSize: 10,
        minHeight: 14,
        padding: '0px 11px',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
    },
});

class CancelOrderButton extends Component {
    cancelWithdrawal = () => {
        let content = (
          <CancelDialog order={this.props.order} />
        );

        this.props.context.update({
            popupContent: content,
            popupTitle:"Cancel Order",
        })
    }

    render() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                <Button className={classes.cancelButton} onClick={this.cancelWithdrawal}>X Cancel</Button>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(CancelOrderButton)));
